export class DeepAnchor {
    static { this.DEEP_ANCHOR = 'deep-anchor'; }
    static _observer(target, anchorName) {
        let hasTarget = window.location.hash === `#${anchorName}` ? true : false;
        const io = new IntersectionObserver((entries) => {
            // Updating the hash in the URL
            if (entries[0].isIntersecting) {
                document.location.hash = anchorName;
            }
            // Scrolling the target element into view
            if (hasTarget && !entries[0].isIntersecting) {
                target?.scrollIntoView({ behavior: 'smooth' });
                hasTarget = false;
            }
        }, {
            threshold: 0.1,
            rootMargin: '5px',
        });
        io.observe(target);
    }
    static wait(ms) {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve('');
            }, ms);
        });
    }
    static async setDeepAnchor(root, cb) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        cb && cb(); // Callback  Execution
        await this.wait(300);
        const name = root?.getAttribute(this.DEEP_ANCHOR);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        name && root && this._observer(root, name);
    }
    static setAllDeepAnchor(root, callbacks) {
        const nodes = root
            ? root.querySelectorAll(`[${this.DEEP_ANCHOR}]`)
            : document.querySelectorAll(`[${this.DEEP_ANCHOR}]`);
        nodes.forEach(async (node) => {
            const name = node?.getAttribute(this.DEEP_ANCHOR);
            // prettier-ignore
            const fn = callbacks && callbacks.find((callback) => callback.deepAnchorName === name);
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            fn && fn.cb();
            await this.wait(300);
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            name && this._observer(node, name);
        });
    }
}
export default DeepAnchor;
//# sourceMappingURL=deep-anchor-util.ts.js.map